
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    providerInvoiceproviderInvoicePageInit,
    providerInvoiceproviderInvoiceDownLoad
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private alltotal = 0

    private mounted () {
      this.gettablelist()
    }


    private async down(row){
      try{
        await providerInvoiceproviderInvoiceDownLoad({Id:row.Id})
        window.open(row.InvoiceLinkUrlComplete)
      }finally{
        //
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.doSearch()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = providerInvoiceproviderInvoicePageInit({
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        })
        let res:any = await (data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
          this.alltotal = res.Result.UpLoadInvoiceCount
        }
      }finally{
        this.tableloading = false
      }
    }
  }
